<template>
    <div>
<!--        <nav class="navbar navbar-light">-->
        <div class="ml-auto">
        <form class="form-inline my-2 my-lg-0">
                    <multiselect
                        style="height: 100%"
                        v-model="search.code"
                        class="form-control border-0"
                        :options="optionProducts"
                        :customLabel="LabelSkuWithName"
                        placeholder="ค้นหาสินค้า"
                        :show-labels="false"
                        :close-on-select="false"
                        multiple
                        :searchable="true"
                        track-by="id">
                    </multiselect>
                    &nbsp
                    <select class="form-control" v-model="search.type">
                        <option v-for="options in productType"
                                :value="options.value">
                            {{ options.text }}
                        </option>
                    </select> &nbsp
                    <date-picker v-model="search.date"
                                 range
                                 :disabled="search.month ? true : false"
                                 @clear="clearDate()"
                                 placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                                 :format="changeFormat"
                                 :lang="lang" confirm>
                    </date-picker>
                    &nbsp
                    <date-picker
                        :disabled="search.date.length > 0 ? true : false"
                        :lang="lang"
                        @clear="clearDate()"
                        type="month"
                        :format="changeFormat"
                        v-model="search.month"
                        placeholder="เดือน-ปี"
                        format="MM/YYYY">
                    </date-picker>
                    &nbsp
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchOverview"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    <button class="btn btn-info" type="button" @click="printOverviewProducts">
                        <icon name="print"></icon>
                        พิมพ์ข้อมูล
                    </button>
                </form>
        </div>
<!--        </nav>-->
<!--        <div style="padding-right: 10px; color: red">**รายงานการจองจะแสดงการจองของวันปัจจุบัน กรุณาเลือกวันที่เพื่อดูรายงานการจองของแต่ละวัน</div>-->
        <div style="padding-right: 10px; color: red">**รายงานการจองจะแสดงการจองทั้งหมด และการจองของเดือนนี้หากไม่ได้เลือกวันที่</div>
        <div class="col-sm-12 center table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">รหัสสินค้า</th>
                    <th scope="col">ชื่อสินค้า</th>
                    <th scope="col">จำนวนคงเหลือ</th>
                    <th scope="col">จำนวนจอง(ค้าง)</th>
                    <th scope="col">จำนวนจอง(ทั้งหมด)</th>
<!--                    <th scope="col" v-if="user.id == 36">order_id</th>-->
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in reservation">
                    <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
                    <td>
                        <template v-if="data.product">
                            {{data.product.sku}}
                        </template>
                        <template v-else>
                            <p>-</p>
                        </template>
                    </td>
                    <td>
                        <template v-if="data.product">
                            {{data.product.name}}
                        </template>
                        <template v-else>
                            <p>-</p>
                        </template>
                    </td>
                    <td>
                        <template v-if="data.product">
                            {{data.product.quantity}}
                        </template>
                        <template v-else>
                            <p>-</p>
                        </template>
                    </td>
                    <td>{{data.total_remaining | amount}}</td>
                    <td>{{data.all_total | amount}}</td>
<!--                    <td v-if="user.id == 36">-->
<!--                        {{data.order_id}}-->
<!--                    </td>-->
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="reservation.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getOverView(dataPaginate.current_page)">
            </vue-pagination>
        </div>
        <br />
<!--        <pre class="alert alert-primary">{{ reservation }}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import Table from "bootstrap-vue/src/components/table/table";
    import VuePagination from "../Pagination";
    import DatePicker from 'vue2-datepicker'
    import moment from 'moment';
    import {domain} from "../../util/Constants";
    import Multiselect from "vue-multiselect";

    export default {
        components: {
            VuePagination,
            DatePicker,
            Multiselect,
            Table},
        name: "reservations-table",
        data(){
          return {
              reservation : [],
              page : 1,
              search : {
                  date : [] ,
                  code : [],
                  type : "",
                  month : ''
              },
              event_submit : false,
              dataPaginate: {
                  current_page: 1,
                  from: 1,
                  last_page: 1,
                  per_page: 1,
                  total: 1,
                  to: 1
              },
              changeFormat: {
                  stringify: (date) => {
                      let date_moment = moment(date).format('YYYY');
                      const year = parseInt(date_moment) + 543;
                      return date ? moment(date).format('DD/MM/'+year) : null
                  },
                  parse: (value) => {
                      return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                  }
              },
              lang: {
                  days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                  months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                  pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                  placeholder: {
                      date: 'วว/ดด/ปปปป',
                  }
              },
          }
        },
        created(){
            this.$store.dispatch('ProductType/get');
            this.$store.dispatch('ProductType/productForStock');
            this.search.month = moment().format('YYYY-MM');
            this.getOverView();
        },
        computed:{
            ...mapState({
                productType:state=>{
                    return [
                        {
                            value: "",
                            text: "ประเภทสินค้า"
                        },
                        ...state.ProductType.data.map(type => ({
                            value: type.id,
                            text: type.name
                        }))
                    ];
                },
                user : state=>{
                    return state.Auth.user;
                },
                optionProducts : state=>{
                    return state.ProductType.product;
                },
            })
        },
        methods:{
            LabelSkuWithName(option){
                if(this.optionProducts.length > 0){
                    return `${option.sku} - ${option.name}`
                }
            },
            clearDate(){
                this.search.date = [];
                this.search.month = '';
            },
            getOverView(page){
                this.page = page?page:1;
                let product_id = '';
                this.search.code.forEach((v,i) => {
                    i>0?product_id+=','+v.id:product_id+=v.id;
                })
                let data = {
                    start_date : this.search.date.length>0?moment(this.search.date[0]).format('YYYY-MM-DD'):'',
                    end_date : this.search.date.length>0?moment(this.search.date[1]).format('YYYY-MM-DD'):'',
                    product_sku : product_id,
                    product_type_id : this.search.type,
                    month : moment(this.search.month).format('YYYY-MM'),
                    type: ''
                }

                this.$store.dispatch('ProductOverview/get', {
                    page : this.page,
                    data : data
                }).then(res=>{
                        this.reservation = res.data
                        this.dataPaginate = {
                            current_page: res.current_page,
                            from: res.from,
                            last_page: res.last_page,
                            per_page: res.per_page,
                            total: res.total,
                            to: res.to
                        }
                    });
            },
            printOverviewProducts(){
                if(this.search.date.length > 0 || this.search.month){
                    let product_id = '';
                    this.search.code.forEach((v,i) => {
                        i>0?product_id+=','+v.id:product_id+=v.id;
                    })
                    let data = {
                        start_date : this.search.date.length>0?moment(this.search.date[0]).format('YYYY-MM-DD'):'',
                        end_date : this.search.date.length>0?moment(this.search.date[1]).format('YYYY-MM-DD'):'',
                        product_sku : product_id,
                        product_type_id : this.search.type,
                        month : moment(this.search.month).format('YYYY-MM'),
                        type: 'excel'
                    }
                    window.open( `${domain}/overview-product?start_date=${data.start_date} +
                                    &end_date=${data.end_date} +
                                    &product_sku=${data.product_sku} +
                                    &product_type_id=${data.product_type_id} +
                                    &month=${data.month} +
                                    &type=${data.type}`);
                }else{
                    alert("กรุณาเลือกช่วงวันที่");
                    // this.$store.dispatch('ProductOverview/get', {
                    //     page : '1',
                    //     data : data
                    // });
                }
            },
            searchOverview(){
                // if(this.search.date.length < 1){
                //     alert("กรุณาเลือกช่วงวันที่");
                // }else{
                    this.getOverView(1);
                // }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .center {
        margin: auto;
        width: 100%;
        padding: 10px;
    }
    /*td:nth-of-type(1):before {*/
        /*content: "ลำดับ";*/
    /*}*/
    /*td:nth-of-type(2):before {*/
        /*content: "รหัสสินค้า";*/
    /*}*/
    /*td:nth-of-type(3):before {*/
        /*content: "ชื่อสินค้า";*/
    /*}*/
    /*td:nth-of-type(4):before {*/
        /*content: "จำนวน";*/
    /*}*/
</style>
